// URL Parameter Keys
export const PARAM_Q = 'q';
export const PARAM_HOTEL_DIRECT_ID = 'hotelDirectId';
export const PARAM_GEO_CODE = 'geoCode';
export const PARAM_GEO_TYPE = 'geoType';
export const PARAM_DATE = 'dateIn';
export const PARAM_NIGHT = 'nbNight';
export const PARAM_AUTOCOMPLETE = 'isAutocomplete';
export const PARAM_APARTMENT = 'apartment';
export const PARAM_SORT = 'sort';
export const PARAM_CURRENCY = 'currency';
export const PARAM_COUNTRY = 'countryMarket';
export const PARAM_OFFER = 'offerId';
export const HOTEL_TYPE = 'hotelType';
export const AMENITIES = 'amenities';
export const PRICE_RANGE = 'priceRange';
export const ROOM_ID = 'roomId';
export const RATE_ID = 'roomRateId';
export const APARTMENT_ID = 'apartmentId';
export const HOTEL_ID = 'hotelId';
export const RADIUS = 'radius';
export const UNIT = 'unit';

export const SEARCH_FILTERS = [
  PRICE_RANGE,
  AMENITIES,
  HOTEL_TYPE,
];

// Redux Action Types
export const SYNC_URL_COMPLETE = 'url/SYNC_COMPLETE'; // Updates parameters AND uiParams
export const UPDATE_UI_PARAM = 'url/UPDATE_UI_PARAM'; // Updates ONLY uiParams (draft)
export const RESET_UI_PARAMS = 'url/RESET_UI_PARAMS'; // Reverts uiParams to parameters
